export default __webpack_public_path__ + "static/media/Gaggenau.9e839e6f.svg";